var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"browser-error\">\n<p class=\"text-center\">\n<span translate>\nHuomasimme, että käytät selainta <strong>{{$ctrl.browser}}</strong>. Tietoturvan ja sivuston toimintojen varmistamiseksi suosittelemme päivittämistä johonkin seuraavista uusista toimiviksi testatuista vaihtoehdoista:\n</span>\n<a href=\"https://www.google.fi/chrome/\" target=\"_blank\">\nGoogle&nbsp;Chrome\n</a>\n<a href=\"https://www.mozilla.org/firefox/\" target=\"_blank\">\nMozilla&nbsp;Firefox\n</a>\n<a href=\"https://support.microsoft.com/en-us/help/17621/internet-explorer-downloads\" target=\"_blank\">\nInternet&nbsp;Explorer&nbsp;11\n</a>\n</p>\n</div>\n";
var id1="app/common/components/browser-error.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/browser-error.tpl.html
// module id = 434
// module chunks = 4